import type { InfiniteData } from '@tanstack/react-query'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import { queryClient } from '@core/Data/ReactQuery/queryClient'
import { betLoopPrincipleProfileQuery } from '@core/Areas/BetLoop/helpers/queries'
import type { BetLoopSharedBet, BetLoopProfile } from '@core/Areas/BetLoop/types'

export function patchFeedDataWithIsFollowingChange({
  profileId,
  isFollowing,
}: {
  profileId: string
  isFollowing: boolean
}) {
  patchFeeds(old =>
    old
      ? {
          ...old,
          pages: old.pages.map(page =>
            page.map(bet => {
              let ownerAccountFollowerCount = bet.ownerAccountFollowerCount
              return bet.ownerAccountId === profileId
                ? {
                    ...bet,
                    isFollowing,
                    isNotificationsEnabled: false,
                    ownerAccountFollowerCount: isFollowing
                      ? ++ownerAccountFollowerCount
                      : --ownerAccountFollowerCount,
                  }
                : bet
            })
          ),
        }
      : old
  )
}

export function patchFeedDataWithNotificationChange({
  accountId,
  isNotificationsEnabled,
}: {
  accountId: string
  isNotificationsEnabled: boolean
}) {
  patchFeeds(old =>
    old
      ? {
          ...old,
          pages: old.pages.map(page =>
            page.map(bet =>
              bet.ownerAccountId === accountId ? { ...bet, isNotificationsEnabled } : bet
            )
          ),
        }
      : old
  )
}

export function patchPrincipalDataWithFollowingCount(isNowFollowing: boolean) {
  const delta = isNowFollowing ? 1 : -1
  queryClient.setQueryData<BetLoopProfile>(betLoopPrincipleProfileQuery.queryKey, old =>
    old ? { ...old, followingCount: Math.max(0, old.followingCount + delta) } : old
  )
}

// =============
// Local Helpers
// =============

function patchFeeds(
  updater: (old?: InfiniteData<BetLoopSharedBet[]>) => InfiniteData<BetLoopSharedBet[]> | undefined
) {
  queryClient.setQueriesData<InfiniteData<BetLoopSharedBet[]>>(
    { queryKey: queryKeys.betLoopSharedBetsFeedBase() },
    updater
  )
}
